import React, { useEffect, useMemo, useRef } from 'react';
import { renderLatexToHtml } from '../services/latexRenderer';
import { wrapMathExpressionsInDom } from '../services/selfContainedHtml';
import DOMPurify from 'dompurify';

// مجاز بودن تگ‌ها/اتریبیوت‌های خروجی ادیتور (فرمول، تصویر شناور، جدول و...)
const sanitizeHtml = (dirty) =>
  DOMPurify.sanitize(dirty, {
    ADD_ATTR: [
      'data-type', 'data-latex', 'data-align', 'data-width',
      'style', 'target', 'dir',
    ],
  });

// رندر استاتیک فرمول‌ها با KaTeX + اعداد فارسی و چیدمان یکپارچه LTR (خروجی نهایی برای نمایش/چاپ)
const renderMathInHtml = (container) => {
  const mathNodes = container.querySelectorAll('.math-formula-container');
  mathNodes.forEach((node) => {
    const latex = node.getAttribute('data-latex');
    if (!latex || node.dataset.rendered === 'true') return;
    node.innerHTML = renderLatexToHtml(latex);
    node.dataset.rendered = 'true';
  });

  wrapMathExpressionsInDom(container);
};

const ArticleRenderer = ({ htmlContent, isA4View = false }) => {
  const contentRef = useRef(null);

  // محتوا قبل از درج در صفحه پاکسازی می‌شود (محافظت XSS)
  const cleanHtml = useMemo(() => sanitizeHtml(htmlContent || ''), [htmlContent]);

  useEffect(() => {
    if (contentRef.current) {
      renderMathInHtml(contentRef.current);
    }
  }, [cleanHtml]);

  return (
    <div
      className={`article-content dir-rtl text-right ${isA4View ? 'a4-print-view' : ''}`}
      ref={contentRef}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default ArticleRenderer;
